<template>
  <div>
    <div class="site-banner">
      <div class="banner-major">
        <div class="container">
          <div class="site-banner-picture">
            <template v-if="item.section_value.bannerimage_link">
              <a :href="item.section_value.bannerimage_link" target="_blank">
                <picture>
                  <source
                    :srcset="currentUrl + '/img/sale_page_single/' + item.section_value.bannerimage_image"
                    media="(min-width: 1000px)"
                  />
                  <source
                    :srcset="currentUrl + '/img/sale_page_single/' + item.section_value.bannerimage_image"
                    media="(min-width: 320px)"
                  />
                  <img
                    :src="currentUrl + '/img/sale_page_single/' + item.section_value.bannerimage_image"
                  />
                </picture>
              </a>
            </template>

            <template v-else>
              <picture>
                <source
                  :srcset="currentUrl + '/img/sale_page_single/' + item.section_value.bannerimage_image"
                  media="(min-width: 1000px)"
                />
                <source
                  :srcset="currentUrl + '/img/sale_page_single/' + item.section_value.bannerimage_image"
                  media="(min-width: 320px)"
                />
                <img
                  :src="currentUrl + '/img/sale_page_single/' + item.section_value.bannerimage_image"
                />
              </picture>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    item: { type: Object, required: true }
  },
  computed: {
    ...mapGetters(["currentUrl"])
  }
};
</script>

<style lang="scss" scoped>
</style>